import CompetitorAlternativePage from '@/components/Pages/CompetitorAlternativePage';
import { MONICA_ALTERNATIVE } from '@/constants/competitorAlternatives';

export default function MonicaAlternativePage() {
  return (
    <CompetitorAlternativePage
      title="Monica Alternative — Full Super Intelligence Workspace"
      description="A Monica alternative with GPT, Claude, Gemini, and Arya in one private workspace — chat, images, video, music, and apps."
      canonical="/monica-alternative"
      keywords="Monica alternative, alternative to Monica Super Intelligence, Monica Super Intelligence alternative, better than Monica, Monica competitor, apps like Monica, free Monica alternative, best Monica alternative"
      page={MONICA_ALTERNATIVE}
    />
  );
}
